
import React from "react";

interface LoadingButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isLoading?: boolean;
    loadingText?: string;
    children: React.ReactNode;
}

export default function LoadingButton({
    isLoading = false,
    loadingText = "Loading...",
    children,
    disabled,
    className = "",
    type = "button",
    ...props
}: LoadingButtonProps) {
    return (
        <button
            type={type}
            disabled={isLoading || disabled}
            className={`
flex
w-full
items-center
justify-center
gap-2
rounded-lg
bg-blue-600
px-4
py-3
text-base
font-semibold
text-white
shadow-sm
transition-all
duration-300
hover:bg-blue-700
hover:scale-[1.01]
focus:outline-none
focus:ring-2
focus:ring-blue-600
focus:ring-offset-2
disabled:cursor-not-allowed
disabled:opacity-60
${className}
`}
            {...props}
        >
            {isLoading ? (
                <>
                    <span
                        className="
                            h-5
                            w-5
                            animate-spin
                            rounded-full
                            border-2
                            border-white/30
                            border-t-white
                        "
                        aria-hidden="true"
                    />

                    <span>{loadingText}</span>
                </>
            ) : (
                children
            )}
        </button>
    );
}
